import { DateTime } from 'luxon';
import {
  RequestType,
  SortRecentOperationalChangesBy,
} from './recentSowChanges.types';
import { SortOrder } from '../../types';

export const recentSowChangesStoreKey = 'recentSowChanges';

export const generateRequestType = (
  currentPage: number,
  limit: number,
  filters: {
    [key: string]: string[];
  },
  fromAndToDate: string[],
  areFiltersApplied: boolean,
  requestType: RequestType,
  sortBy: SortRecentOperationalChangesBy,
  sortOrder: SortOrder,
  shouldApplyFilters?: string,
) => {
  const shouldFetchDataWithFilters = shouldApplyFilters
    ? shouldApplyFilters === 'withFilters'
    : areFiltersApplied;

  return {
    currentPage,
    limit,
    authorIds: shouldFetchDataWithFilters ? filters.authorIds : [],
    reviewerIds: shouldFetchDataWithFilters ? filters.reviewerIds : [],
    actions: shouldFetchDataWithFilters ? filters.actions : [],
    userIds: shouldFetchDataWithFilters ? filters.userIds : [],
    accountIds: shouldFetchDataWithFilters ? filters.accountIds : [],
    projectIds: shouldFetchDataWithFilters ? filters.projectIds : [],
    reqStatus: shouldFetchDataWithFilters ? filters.reqStatus : [],
    fromDate: fromAndToDate?.length
      ? DateTime.fromFormat(fromAndToDate[0], 'yyyyMM').startOf('month').toISO()
      : null,
    toDate: fromAndToDate?.length
      ? DateTime.fromFormat(fromAndToDate[1], 'yyyyMM')
          .endOf('month')
          .endOf('day')
          .toISO()
      : null,
    requestType: requestType,
    sortBy,
    sortOrder: sortOrder === 0 ? 'ASC' : 'DESC',
  };
};
